import React, { Component } from "react";
import { Grid, Input, Button, Label } from "semantic-ui-react";
import moment from "moment";

import {deleteservice } from "../../../services/crudservice";
import "../accounting.css";
import TMTable from "./tmtable";
import { app } from "../../..";
class MassDelete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tnms: [],
      deletetnms: [],
      date: null
    };
  }
  massdelete(date) {
    app.service("tmsheets").find({query: {wedate: date}}).then(tmstuffs => {
      this.setState({
        tnms: tmstuffs,
        deletetnms: tmstuffs
      });
    });
  }
  handletmstate(tnm) {
    let newtms = this.state.deletetnms;
    let newtmindex = newtms.findIndex(i => i.id === tnm.id);
    if (newtmindex === -1) {
      newtms = newtms.concat(tnm);
    } else {
      newtms.remove(newtmindex);
    }
    this.setState({ deletetnms: newtms });
  }
  deletetnm() {
    this.state.deletetnms.map(tnm => deleteservice("tmsheets", tnm.id));
  }
  renderbutton() {
    if (this.state.date !== null) {
      if (this.state.tnms.length === 0) {
        return (
          <Button
            color="blue"
            onClick={() => {
              this.props.handlepost(this.state.tnms);
            }}
          >
            Find T&M's
          </Button>
        );
      } else {
        return (
          <Button
            color="red"
            onClick={() => {
              this.deletetnm();
            }}
          >
            Delete T&M's
          </Button>
        );
      }
    }
  }
  render() {
    const today = moment().format("DD/MM/YYYY");
    return (
      <div className="MassDelete">
        <Grid>
          <Grid.Row centered>
            <Grid.Column width={6}>
              <Label>Select date to Find TNMS</Label>
              <Input
                type="date"
                name="enddate"
                onChange={e => this.setState({ date: e.target.value })}
                defaultValue={today}
                fluid
              />
            </Grid.Column>
            <Grid.Column width={2}>{this.renderbutton()}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={10}>
              <TMTable
                tnms={this.state.tnms}
                massdelete
                handleDelList={tnm => this.handletmstate(tnm)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default MassDelete;



// WEBPACK FOOTER //
// ./src/components/accounting/tnm/massdeltnm.jsx